const cloudgame = {
  state: {
    showCookieSettings: false,
    showCookieDetail: false,
    isOperate: false,
    isBannerShow: false,
    isUserAcceptCookie: false, // 用户是否同意存功能cookies
    thirdLoginUserInfo: "",
    showFullScreenBox: false,
    isExpire: false,  //discord链接是否已经过期
    showMenuH5: false,
    showMenuPC: false,
    showGameDelayTip: true,
    showFloatingBall: true,
    iRemainedTime: 0,
    isShowDownloadActivity: false,
    isInGame: false,
    isShowTip: false, // 残局游戏tip
  },
  mutations: {
    SET_SHOW_COOKIE_SETTINGS: (state, show) => {
      state.showCookieSettings = show;
    },
    SET_SHOW_COOKIE_DETAIL: (state, show) => {
      state.showCookieDetail = show;
    },
    SET_IS_OPERATE: (state, opt) => {
      state.isOperate = opt;
    },
    SET_IS_BANNER_SHOW: (state, show) => {
      state.isBannerShow = show;
    },
    SET_IS_USER_ACCEPT_COOKIE: (state, acc) => {
      state.isUserAcceptCookie = acc;
    },
    SET_THIRD_LOGIN_INFO: (state, info) => {
      state.thirdLoginUserInfo = info;
    },
    SET_SHOW_FULLSCREEN_BOX: (state, show) => {
      state.showFullScreenBox = show;
    },
    SET_EXPIRE: (state, show) => {
      state.isExpire = show;
    },
    TOGGLE_MENU_H5: (state, show) => {
      state.showMenuH5 = show;
    },
    TOGGLE_MENU_PC: (state, show) => {
      state.showMenuPC = show;
    },
    SET_GAME_DELAY_TIP: (state, show) => {
      state.showGameDelayTip = show;
    },
    TOGGLE_FLOATING_BALL: (state, show) => {
      state.showFloatingBall = show;
    },
    SET_REMAINED_TIME: (state, time) => {
      state.iRemainedTime = time;
    },
    SET_SHOW_DOWNLOAD_ACTIVITY: (state, show) => {
      state.isShowDownloadActivity = show;
    },
    SET_IS_IN_GAME: (state, show) => {
      state.isInGame = show;
    },
    SET_IS_SHOW_TIP: (state, show) => {
      state.isShowTip = show;
    }
  },
};
export default cloudgame;
